import "../../App.css";
import { Routes, Route } from "react-router-dom";
import { HomePage } from "./Home/Home";
import Nopage from "../Nopage/Nopage";
import LandingPagesLayout from "./Layout/Layout";
import AboutPage from "./About/About";
import TermsAndCondtions from "./TermsAndCondtions/TermsAndCondtions";
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy";
import ServicesPage from "./Services/Services";
import ServiceDetailsPage from "./Services/ServicesDetails";
import ContactPage from "./Contact/Contact";
import ScrollToTop from "../../utils/scrollToTop";
import OurJobPage from "./OurJobs/OurJobs";
import IndexPage from "./Home/Index";
import JobDetailsPage from "./OurJobs/JobDetails";
import ProductInventoryPage from "./Products/ProductInventory";
import RoomList from "./RoomService/RoomList";
import RoomDetails from "./RoomService/RoomDetails";

const LandingPagesRoute = () => {
  const scrollToTop = ScrollToTop();
  return (
    <Routes>
      <Route path="/" element={<LandingPagesLayout />}>
        <Route index element={<ProductInventoryPage />} />
        <Route path="home" element={<ProductInventoryPage />} />
        {/* <Route path="home" element={<IndexPage />} /> */}
        <Route path="about" element={<AboutPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="ourjobs" element={<OurJobPage />} />
        <Route path="ourjobs/:id/:title" element={<JobDetailsPage />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="services/:id/:title" element={<ServiceDetailsPage />} />
        <Route
          path="product/inventory_Software"
          element={<ProductInventoryPage />}
        />
        <Route path="terms_and_condition" element={<TermsAndCondtions />} />
        <Route path="privacy_policy" element={<PrivacyPolicy />} />
        <Route path="room-service" element={<RoomList />} />
        <Route path="room-service/:roomId" element={<RoomDetails />} />
        <Route path="*" element={<Nopage />} />
      </Route>
    </Routes>
  );
};

export default LandingPagesRoute;
